import { LoadingOutlined } from '@ant-design/icons'
import { Alert, Spin } from 'antd'
import { ReactChild } from 'react'

import Box from '~/core/Box'

interface AlertBeforeDataSyncProps {
    status: string
    description: ReactChild
    subDescription: string
}

const AlertBeforeDataSync = ({
    status,
    description,
    subDescription,
}: AlertBeforeDataSyncProps) => {
    return (
        <>
            <Alert
                type="info"
                showIcon
                message={status}
                description={description}
            />
            <Box marginTop="1em" justifyContent="center">
                <Spin
                    indicator={
                        <LoadingOutlined
                            style={{
                                fontSize: 24,
                                color: '#00000040',
                            }}
                            spin
                        />
                    }
                    size="large"
                />
            </Box>
            <Box marginTop="1em" justifyContent="center">
                {subDescription}
            </Box>
        </>
    )
}

export default AlertBeforeDataSync
